export const PENDING_PURCHASE_ORDERS_ACTION = 'PENDING_PURCHASE_ORDERS_ACTION'
export const COMPLETED_PURCHASE_ORDERS_ACTION =
  'COMPLETED_PURCHASE_ORDERS_ACTION'
export const RESET_PURCHASE_ORDERS_ACTION = 'RESET_PURCHASE_ORDERS_ACTION'
export const SET_PURCHASE_ORDER = 'SET_PURCHASE_ORDER'
export const SET_PURCHASE_ORDERS = 'SET_PURCHASE_ORDERS'
export const SET_PURCHASE_ORDER_TABLE_METADATA =
  'SET_PURCHASE_ORDER_TABLE_METADATA'
